

const MessageImages = ({ content }) => {
    if (!Array.isArray(content)) return null;

    // Filter for content blocks that are images and that already have a signed URL.
    const imageBlocks = content.filter(
        (block) => block.type === "image_url" && block.image_url?.url
    );

    if (imageBlocks.length === 0) return null;

    return (
        // Outer container uses RTL to fix the scroll position to the right.
        <div className="w-full relative mr-0" dir="rtl">
            {/* Inner container is horizontally scrollable and uses a unique class */}
            <div className="overflow-x-auto image-scroll">
                <div className="flex items-end gap-2">
                    {imageBlocks.map((block, idx) => (
                        <img
                            key={idx}
                            src={block.image_url.url}
                            alt="Chat Image"
                            className="object-contain rounded flex-none max-w-[150px] max-h-[150px]"
                            // Each image uses LTR so its content displays normally.
                            dir="ltr"
                        />
                    ))}
                </div>
            </div>
            {/* Inline CSS for a very thin scrollbar with no track background */}
            <style>{`
          .image-scroll::-webkit-scrollbar {
            width: 0px;
          }
          .image-scroll::-webkit-scrollbar-track {
            background: transparent;
          }
          .image-scroll::-webkit-scrollbar-thumb {
            background: #3f3f46;
            border-radius: 9999px;
          }
          .image-scroll::-webkit-scrollbar-thumb:hover {
            background: #52525b;
          }
        `}</style>
        </div>
    );
};

export default MessageImages;